var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "15px",
    viewBox: "0 0 9 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6F63A1FE-1BBD-426D-8E6A-6403A88A00D9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart\\xE3o",
    transform: "translate(-1114.000000, -36.000000)",
    fill: "#E71037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-(1)",
    transform: "translate(1114.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75563713,6.91469988 L1.9383212,0.239632198 C1.78064501,0.0851212592 1.57016099,0 1.34572773,0 C1.12129447,0 0.910810445,0.0851212592 0.753134249,0.239632198 L0.251086265,0.731091617 C-0.0755998825,1.05133292 -0.0755998825,1.57181649 0.251086265,1.89156999 L5.97575348,7.49689027 L0.244734381,13.10843 C0.0870581842,13.262941 0,13.4689149 0,13.6885472 C0,13.9084235 0.0870581842,14.1143974 0.244734381,14.2690303 L0.746782364,14.7603678 C0.904583107,14.9148787 1.11494258,15 1.33937584,15 C1.5638091,15 1.77429312,14.9148787 1.93196932,14.7603678 L8.75563713,8.07920261 C8.91368696,7.92420387 9.00049605,7.71725433 8.99999787,7.49725612 C9.00049605,7.27640426 8.91368696,7.06957667 8.75563713,6.91469988 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.b1fd690a2368e62f3c7e9dd18f0dfb21.svg";
export { ForwardRef as ReactComponent };